import { GetFundType } from "./types";

export const fundSlr = (state: any): GetFundType => state.fund;
